export const SET_QRY_STR_MEDIUM = "SET_MEDIUM";
export const SET_QRY_STR_SOURCE = "SET_SOURCE";
export const CLEAR_QUERY_STRINGS = "CLEAR_QUERY_STRINGS";
export const SET_QRY_STR_MODE = "SET_QRY_STR_MODE";
export const SET_QRY_STR_DEVICE = "SET_QRY_STR_DEVICE";
export const SET_QRY_STR_TCP_MIDDELWARE_ADDR =
  "SET_QRY_STR_TCP_MIDDELWARE_ADDR";
export const SET_QRY_STR_TCP_MIDDELWARE_PORT =
  "SET_QRY_STR_TCP_MIDDELWARE_PORT";
